module.exports = __webpack_public_path__ + "img/protfolio-item-1.f4391a9f.png";